/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesCostWeightage {
    getFixupPrototypeFunction() { return KubernetesCostWeightage.fixupPrototype; }

    static newInstance(model: Partial<KubernetesCostWeightage>): KubernetesCostWeightage {
        let obj = Object.assign(new KubernetesCostWeightage(), model);
        KubernetesCostWeightage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesCostWeightage>): KubernetesCostWeightage {
        if (!model) return null;
        return KubernetesCostWeightage.newInstance(<KubernetesCostWeightage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesCostWeightage) {
        if (!obj) return;

        models.KubernetesCostWeightage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesCostWeightage): boolean {
        Object.setPrototypeOf(obj, KubernetesCostWeightage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cpu_weight === undefined) {
            this.cpu_weight = 0;
        }
        if (this.memory_weight === undefined) {
            this.memory_weight = 0;
        }
        if (this.gpu_weight === undefined) {
            this.gpu_weight = 0;
        }
    }

    /**
     * CPU cost weight
     */
    cpu_weight: number;

    /**
     * Memory cost weight
     */
    memory_weight: number;

    /**
     * GPU cost weight
     */
    gpu_weight: number;

}
